module.exports = __webpack_public_path__ + "img/SmartSlides.3db0705e.png";